import { formatPhoneNumberIntl } from "react-phone-number-input";
import validator from "validator";

export const isValidEmail = (email) => {
  return validator.isEmail(email);
};

export const formatSwissPrice = (value, withCurrency = false) => {
  let number = Number(value);
  if (isNaN(number)) return null;
  number = Math.round(number * 20) / 20;
  return `${number.toFixed(2)}${withCurrency ? " CHF" : ""}`;
};

export const groupDishesByCategories = (dishes) => {
  const groupedDishes = dishes.reduce((grouped, dish) => {
    const categoryLabel = dish.dishcategory ? dish.dishcategory.label : "";
    (grouped[categoryLabel] = grouped[categoryLabel] || []).push(dish);
    return grouped;
  }, {});
  Object.keys(groupedDishes).forEach((key) => {
    groupedDishes[key] = groupedDishes[key].sort((a, b) => a.order - b.order);
  });
  return groupedDishes;
};

export const groupDishesByTypes = (dishes) => {
  const groupedDishes = dishes.reduce((grouped, dish) => {
    const typeLabel = dish.dishtype ? dish.dishtype.label : "no_type";
    (grouped[typeLabel] = grouped[typeLabel] || []).push(dish);
    return grouped;
  }, {});
  const sortedKeys = Object.keys(groupedDishes).sort((a, b) => {
    const orderA = groupedDishes[a][0].dishtype.order
      ? groupedDishes[a][0].dishtype.order
      : 100;
    const orderB = groupedDishes[b][0].dishtype.order
      ? groupedDishes[b][0].dishtype.order
      : 100;
    return orderA - orderB;
  });
  const sortedGroupedDishes = {};
  sortedKeys.forEach((key) => {
    sortedGroupedDishes[key] = groupedDishes[key].sort((a, b) => {
      const catA = a.dishcategory?.order ?? Infinity;
      const catB = b.dishcategory?.order ?? Infinity;
      if (catA !== catB) return catA - catB;
      return (a.order ?? 0) - (b.order ?? 0);
    });
  });
  return sortedGroupedDishes;
};

export const formatDate = (
  dateString,
  includeTime = true,
  options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  },
  locale = "fr-CH"
) => {
  const date = new Date(dateString);
  if (!includeTime) {
    delete options.hour;
    delete options.minute;
  }
  return date.toLocaleString(locale, options);
};

export const formatMoney = (
  value = 0,
  locale = "fr-CH",
  options = { style: "currency", currency: "CHF" }
) => {
  return value.toLocaleString(locale, options);
};

export const formatSchedules = (schedules, hasEvening = true) => {
  if (!schedules) return null;
  if (hasEvening)
    return schedules.map((s) => {
      return {
        day: s.day,
        noon: { startAt: s.noonStartAt, endAt: s.noonEndAt },
        evening: { startAt: s.eveningStartAt, endAt: s.eveningEndAt },
      };
    });
  return schedules.map((s) => {
    return {
      day: s.day,
      startAt: s.startAt,
      endAt: s.endAt,
    };
  });
};

export const formatPhoneNumber = (phoneNumber) => {
  return formatPhoneNumberIntl(phoneNumber);
};
